var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/actions/ButtonCreate.tsx",
  _this = this;
import React, { useContext } from 'react';
import { Button } from '@wds/button';
import { T, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { generateMetricsAttribute } from '@sm/metrics';
import HeaderContext from '../../HeaderContext';
import { StaticContext } from '../../../../StaticContext';
export var COPY = defineMessages({
  CREATE_SURVEY: {
    id: 'ButtonCreate.createSurvey',
    defaultMessage: 'Create survey',
    description: '[Type: Label][Vis.: high] - This is the create survey addon button on the header.'
  }
});
var ButtonCreate = function ButtonCreate() {
  var _HEADER_EXP$createSur;
  var _useContext = useContext(HeaderContext),
    pageURL = _useContext.pageURL,
    pageName = _useContext.pageName;
  var _useContext2 = useContext(StaticContext),
    _useContext2$HEADER_E = _useContext2.HEADER_EXP,
    HEADER_EXP = _useContext2$HEADER_E === void 0 ? {} : _useContext2$HEADER_E;
  var experimentTreatment = HEADER_EXP === null || HEADER_EXP === void 0 ? void 0 : (_HEADER_EXP$createSur = HEADER_EXP.createSurveyButton) === null || _HEADER_EXP$createSur === void 0 ? void 0 : _HEADER_EXP$createSur.treatment;
  var isInExperimentTreatment = experimentTreatment && experimentTreatment !== 'existing_flow';
  return /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    color: "alt",
    href: createURL("/create/".concat(isInExperimentTreatment ? 'start/' : ''), {
      ut_source: 'header'
    }),
    "data-sm-metrics": generateMetricsAttribute({
      data: {
        url: pageURL,
        pageName: pageName,
        amplitudeEvent: 'header clicked cta',
        ctaName: 'create survey'
      }
    }),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.CREATE_SURVEY,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 7
    }
  }));
};
export default ButtonCreate;
//# sourceMappingURL=ButtonCreate.js.map